import React, { CSSProperties } from "react";
import { closeBrowser } from '@/common/utils'
const closeStyle: CSSProperties = {
    fontSize: '0.78rem',
    color: 'white'
}

const darkStyle:CSSProperties = {
    fontSize: '0.78rem',
    color: '#000'
}

export default class OmniHeroesClose extends React.Component<{ isDark?: boolean }> {
    render() {
        return (
            <i onClick={() => {
                closeBrowser()
            } } style={this.props?.isDark ? darkStyle : closeStyle} className="iconfont icon-close"></i>
        )
    }
}